(function(window, $){

  const $header = $('.site-header__container');
  const headerHeight = 85;
  const $mobileMenu = $('.mobile-nav');

  let prevScroll = 0;

  $(document).on('scroll', handleScroll);
  $('.menu-toggle').on('click', handleMenuToggleClick);
  $('.mobile-nav__close, .mobile-nav__overlay').on('click', handleCloseNavClick)

  function handleScroll(){
    const scrollTop = $(window).scrollTop();
    const isVisible = prevScroll > scrollTop || scrollTop < headerHeight/2;
    const isMiddleOfPage = scrollTop > headerHeight/2;

    $header.css({
      top: isVisible ? 0 : -headerHeight,
      boxShadow: isMiddleOfPage && isVisible ? '0 3px 20px rgba(0, 32, 57, 0.2)' : 'none',
      background: isMiddleOfPage ? '#fff' : '#fff'
    });

    if (isMiddleOfPage) {
      $header.addClass('site-header__container--middle');
      $header.find('.menu > .menu-item > a').css({
        color: '#002039'
      })
    } else {
      $header.removeClass('site-header__container--middle');
      $header.find('.menu > .menu-item > a').attr('style', '');
    }

    prevScroll = scrollTop;
  }

  function handleMenuToggleClick(){
    $mobileMenu.addClass('mobile-nav--active');
  }

  function handleCloseNavClick(){
    $mobileMenu.removeClass('mobile-nav--active');
  }

  handleScroll();

})(window, jQuery);